import { JSX, useEffect, useMemo, useState } from 'react';
import { getCoreRowModel } from '@tanstack/react-table';

import { Box, Typography } from '@mui/material';

import { getPairingHistoryByDeviceId, getPairingHistoryByEquipmentId } from '../../../services/pairing.service';

import { EquipmentPairing } from '../../../types/EquipmentPairing';

import { Table, useStandardTable as useTable } from '../../common/table';

import makePairingHistoryColumn from './makePairingHistoryColumn';

interface PairingHistoryProps {
  deviceId?: string;
  equipmentId?: string;
  needsUpdate: boolean;
  noCardRadius?: boolean;
}

export default function PairingHistory({ deviceId, equipmentId, needsUpdate, noCardRadius = false }: PairingHistoryProps): JSX.Element {
  const [pairingHistory, setPairingHistory] = useState<EquipmentPairing[]>();

  const getPairingHistory = () => {
    deviceId &&
      getPairingHistoryByDeviceId(deviceId).then((result) => {
        if (result.status === 200) {
          setPairingHistory(result.data);
        }
      });

    equipmentId &&
      getPairingHistoryByEquipmentId(equipmentId).then((result) => {
        if (result.status === 200) {
          setPairingHistory(result.data);
        }
      });
  };

  useEffect(() => {
    getPairingHistory();
  }, [deviceId, equipmentId, needsUpdate]);

  const columns = useMemo(() => makePairingHistoryColumn(), []);
  const table = useTable<any>({
    columns: columns,
    serverSide: false,
  });

  return (
    <>
      <Typography
        variant='caption'
        sx={{
          display: 'block',
          mb: 1,
          fontWeight: 700,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          color: 'text.secondary',
          paddingLeft: 1,
        }}
      >
        Pairing History
      </Typography>
      <Box
        sx={{
          '& .ui-table__card': {
            borderRadius: noCardRadius ? 0 : 4,
            borderColor: '#dbe5f1',
            boxShadow: 'none',
          },
          '& .MuiTableCell-root': {
            py: 0.625,
            px: 1.25,
          },
        }}
      >
        <Table
          {...table}
          data={pairingHistory ?? []}
          showSearchBar={false}
          showColumnToggler={false}
          showAction={false}
          showPagination={false}
          getCoreRowModel={getCoreRowModel()}
        />
      </Box>
    </>
  );
}
